// import numeral from 'numeral'
var numeral = require('numeral')
import { format as d3_format } from 'd3-format'

export function formatNumber(value, format, thou, dec, values) {
  if (format && format.indexOf('%') >= 0) value = value / 100

  // let formattedValue = numeral(value).format(format || '0,0.00')
  if (values && format.indexOf('~s') > 0) {
    values = values.map(d => (d > 1 ? d3_format(format)(d) : d3_format('.2')(d)))
    if (values.some(d => d.indexOf(dec) > 0)) {
      let lenghts = values.map(
        d =>
          String(d).replaceAll(/[^\d]/g, '').replaceAll(/^[0]/g, '').replaceAll(/[0]$/g, '').length
      )
      let precission = Math.max(...lenghts)
      format = `.${precission}s`
    }
  }
  //chapuzilla #103:evitamos los "mili/deci etc.." con el value>1
  let formattedValue = value > 1 ? d3_format(format || '.2s')(value) : d3_format('.2')(value)
  if (value === 0) formattedValue = '0'
  return formattedValue
}
